<template>
<el-container>
  <el-drawer :visible.sync="hotelSearchStar" :title="$t('searchCriteria')" size="85%" class="search-dialog" :with-header="false" :wrapperClosable="true" @close="dialog_close('hotelSearchStar')">
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <i class="el-icon-arrow-left" @click="dialog_close('hotelSearchStar')" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('searchCriteria')}}</div>
    </div>
    <!--搜索 开始-->
    <div class="list-cond">
      <div class="starsearch">
        <div>{{$t('propertyClass')}}</div>
        <div class="starlevel">
          <el-checkbox-group v-model="checkedLevel">
              <div>
                <el-checkbox :id="key" v-for="(level, key) in levels" :label="key" :key="level">
                  <span v-html="propertyClassLanguage(key)"></span>
                </el-checkbox>
              </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="starsearch">
        <div>{{$t('pricePerNight')}}</div>
        <div class="starlevel">
          <el-checkbox-group v-model="checkedBudget" @change="handleCheckedBudgetChange">
              <div><el-checkbox v-for="(budget, key) in budgets" :label="key" :key="budget" :disabled="budgetNo[key]">{{budget}}</el-checkbox></div>
          </el-checkbox-group>
        </div>
      </div>
      <el-button class="hotellist_button" :style="{top: `${buttonTop}px`, width: `${buttonWidth}px`}" style="position:absolute;" @click="submitSearchStar">{{$t('search')}}</el-button>
    </div>
    <!--搜索 结束-->
    </el-drawer>
</el-container>
</template>

<script>
export default {
  name: 'HotelSearchCond',
  props: ['hotelSearchStar', 'showLevel', 'showBudget'],
  components: {
  },
  data () {
    return {
      checkedLevel: [],
      levels: this.common.levelOptions,
      budgets: {},
      checkedBudget: [],
      budgetNo: {5: false, 6: false, 7: false, 8: false, 9: false},
      budgetSelectIds: [],
      budgetRev: {},
      oldBudgetsRev: {},
      selectConds: [],
      selectLevelConds: [],
      selectBudgetConds: [],
      budgetText: ['< CNY 500', 'CNY 500 - 1000', 'CNY 1000 - 1500', 'CNY 1500 - 2500', '> CNY 2500'],
      showFilter: false,
      buttonTop: document.documentElement.clientHeight - 68,
      buttonWidth: document.documentElement.clientWidth * 0.765
    }
  },
  mounted () {
    var showFilter = localStorage.getItem('showFilter')
    if (showFilter !== null && showFilter !== '') {
      this.showFilter = showFilter
      if (this.showFilter === true || this.showFilter === 'true') {
        var star = localStorage.getItem('star')
        if (star !== null && star !== '') {
          this.checkedLevel = JSON.parse(star)
        }
        var budgetInfo = localStorage.getItem('budgetInfo')
        if (budgetInfo !== null && budgetInfo !== '') {
          var budgetArr = JSON.parse(budgetInfo)
          var budget = budgetArr['budget']
          this.checkedBudget = budget
          this.selectBudgetConds = budgetArr['budgetSelect']
          this.budgetSelectIds = budgetArr['budgetSelectIds']
          if (this.checkedBudget.length > 1) {
            budget.sort()
            var num = parseInt(budget[ budget.length - 1 ]) - parseInt(budget[ 0 ])
            if (num > 1) {
              var i
              for (i = 1; i < num; i++) {
                var id = parseInt(budget[ 0 ]) + i
                this.budgetNo[ id ] = true
              }
            }
          }
        }
      }
    }
  },
  methods: {
    propertyClassLanguage (key) {
      return this.$t(this.common.propertyLanguage[key])
    },
    submitSearchStar: function () {
      var star = localStorage.getItem('star')
      var budget = localStorage.getItem('budgetInfo')
      var budgelocal = []
      if (budget !== '' && budget !== null) {
        var budgetArr = JSON.parse(budget)
        if (budgetArr.budget.length !== 0) {
          budgelocal = budgetArr.budget.sort()
        }
      }
      if (JSON.stringify(this.checkedLevel) !== star || JSON.stringify(this.checkedBudget.sort()) !== JSON.stringify(budgelocal)) {
        localStorage.setItem('star', JSON.stringify(this.checkedLevel))
        var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        console.log('=====')
        var submitInfo = {'level': this.checkedLevel, 'budget': this.checkedBudget}
        this.$emit('getSearchStar', submitInfo)
      }

      // 选择星级操作记录埋点
      var selectStar = []
      var selectPrice = []
      this.checkedLevel.forEach((item, index) => {
        selectStar.push(this.common.levelOptions[item].split('/')['0'])
      })
      this.checkedBudget.forEach((item, index) => {
        selectPrice.push(this.budgets[item])
      })
      var selectSearch = {'level': selectStar, 'budget': selectPrice}
      this.clickPageAction('mobile_filter', '', selectSearch)

      this.$options.methods.dialog_close.bind(this)('hotelSearchStar')
    },
    dialog_close: function (type) {
      this.$emit('closepop', type)
    },
    // handlecheckedLevelChange (value) {
    //   localStorage.setItem('star', JSON.stringify(this.checkedLevel))
    // },
    handleCheckedBudgetChange (value) {
      let surplusBudgetSelectConds = []
      // 勾选
      if (this.budgetSelectIds.length < value.length) {
        this.selectBudgetConds.push(this.budgets[ value[ value.length - 1 ] ])
        this.budgetSelectIds.push(value[ value.length - 1 ])
        if (value.length > 1) {
          value.sort()
          var num = parseInt(value[ value.length - 1 ]) - parseInt(value[ 0 ])
          if (num > 1) {
            var i
            for (i = 1; i < num; i++) {
              var id = parseInt(value[ 0 ]) + i
              this.budgetSelectIds.push(id.toString())
              this.budgetNo[ id ] = true
              this.checkedBudget.push(id.toString())
              if (this.selectBudgetConds.includes(this.budgets[ id ])) {
                this.selectBudgetConds.splice(this.selectConds.indexOf(this.budgets[ id ]), 1)
              }
            }
          }
        }
      } else {
        value.forEach((item, index) => {
          surplusBudgetSelectConds.push(this.budgets[ item ])
        })
        // 取消勾选后，没有任何勾选
        if (surplusBudgetSelectConds === '' || surplusBudgetSelectConds === null || surplusBudgetSelectConds.length === 0) {
          this.selectBudgetConds = []
          this.checkedBudget = []
          this.budgetSelectIds = []
        } else {
          // 取消勾选后，还有其他勾选
          this.selectBudgetConds.forEach((item, index) => {
            if (!surplusBudgetSelectConds.includes(item)) {
              var cancelid = this.budgetsRev[ item ]
              this.budgetSelectIds.sort()
              var min = this.budgetSelectIds[ 0 ]
              var max = this.budgetSelectIds[ this.budgetSelectIds.length - 1 ]
              // 如果取消的是最小值，则只保留最大值
              if (parseInt(cancelid) === parseInt(min)) {
                // 取最大值
                this.selectBudgetConds = [ this.budgets[ max ] ]
                this.checkedBudget = [ max.toString() ]
                this.budgetSelectIds = [ max.toString() ]
              } else {
                // 如果取消的是最大值，则只保留最小值
                this.selectBudgetConds = [ this.budgets[ min ] ]
                this.checkedBudget = [ min.toString() ]
                this.budgetSelectIds = [ min.toString() ]
              }
              this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.search-dialog{width:100%;min-height:900px;}
.search-dialog .search-header{width:100%;min-height:50px;background:rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;}
.search-dialog .search-center{width:95%;height:100%;margin:0 auto;}
.search-dialog .search-header .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
.search-dialog .search-header .search-center .search-close{width:15%;height:100%;float:left;}
.search-dialog .search-header .search-center .search-title{width:70%;height:100%;float:left;}
.main{background-color: #fff;width:100%;}
.list-cond{width: 90%;height: auto;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;margin: 0 auto;}
.starsearch{margin-top:28px;font-size: 18px; display: block;}
.starlevel{font-weight: 200;color: #4F4C4C;font-size: 14px;margin-top:5px;display: block;}
.el-checkbox{margin-top:20px;font-weight: 200;display: block;}
.hotellist_button{width:100%;height:48px;font-size:16px;margin: 10px 0px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
.hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/HotelSearchCond.vue